import {Component, EventEmitter, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {FieldConfigName} from '../../../models';
import {TextInputDialogComponent} from './text-input-dialog.component';
import {FieldControlMaster} from '../control-master-label-required';

@Component({
  selector: 'app-text-input',
  templateUrl: './text-input.component.html',
  styleUrls: ['./text-input.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TextInputComponent extends FieldControlMaster implements OnInit {
  @Output() textInputUpdateControl = new EventEmitter<{ control: FieldConfigName, index: number }>();
  @Output() textInputDelete = new EventEmitter<number>();
  dialogComponent = TextInputDialogComponent;

  constructor() {
    super();
  }
  ngOnInit(): void {
  }
  onUpdatedControl(object) {
    this.textInputUpdateControl.emit(object);
  }
  onDeletedControl(index: number) {
    this.textInputDelete.emit(index);
  }
}
